const HUB_PLAY_URL = 'https://level.farm/api/stats/play';
const TIMEOUT_MS = 2500;

export type HubGameKind = 'classic' | 'original';

/**
 * Ping fire-and-forget : une fois par partie, jamais bloquant.
 * Compte optionnel (cookie lf_session). Offline / erreur → no-op.
 */
export function trackPlay(opts: { gameSlug: string; gameKind: HubGameKind }): void {
  try {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) return;
    const gameSlug = String(opts.gameSlug || '').trim().toLowerCase();
    const gameKind = opts.gameKind;
    if (!gameSlug || (gameKind !== 'classic' && gameKind !== 'original')) return;
    const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timer = ctrl ? setTimeout(() => ctrl.abort(), TIMEOUT_MS) : 0;
    const done = (): void => {
      if (timer) clearTimeout(timer);
    };
    void fetch(HUB_PLAY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      keepalive: true,
      body: JSON.stringify({ gameSlug, gameKind }),
      signal: ctrl?.signal,
    }).then(done, done);
  } catch {
    /* fire-and-forget */
  }
}

export function makePlayPing(gameSlug: string, gameKind: HubGameKind = 'classic'): {
  begin: () => void;
  note: () => void;
} {
  let sent = false;
  return {
    begin() {
      sent = false;
      this.note();
    },
    note() {
      if (sent) return;
      sent = true;
      trackPlay({ gameSlug, gameKind });
    },
  };
}
